import React from 'react';
import CoverImage from 'components/Learn/shared/CardCoverImage';
import TextPlaceholder from 'components/shared/TextPlaceholder';

const COVER_WIDTH = 222;
const COVER_HEIGHT = 125;

const LessonCardPreview = ({ image }) => (
  <div className="Card LearnContentCard LearnContentCard--hasImage">
    <CoverImage image={image} width={COVER_WIDTH} height={COVER_HEIGHT} />
    <div className="Card-content Card-content--mediumPadding LearnContentCard-content">
      <div className="LearnContentCard-title">
        <div>
          <span
            style={{
              display: 'block',
              position: 'relative',
              overflow: 'hidden',
              maxHeight: '88px',
            }}
          >
            <TextPlaceholder minWidth={80} />
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default LessonCardPreview;
